export const opsViewSourceId = 'ops-view-source';

export const opsViewTrackingCircleAndHeadingLineSourceId = `${opsViewSourceId}_tracking_circle_and_heading_line`;
export const opsViewAircraftSourceId = 'ops-view-source_aircraft';
export const opsViewUsersSourceId = `ops_view_users_source`;
export const opsViewAircraftLayerId = 'ops-view-aircraft_icon_layer';
export const opsViewUsersCircleLayerId = 'ops-view-users_circle_layer';

//Types of objects in opsView
//userStream - phone
//userOnly - phone
//aircraftStream - aircraft
//aircraftOnly - aircraft
//streamOnly - video icon

export const aircraftIconExpression = [
	'case',
	// is_sim === true → simulator
	['==', ['get', 'is_sim'], true],
	'simulator_icon',

	// else:
	[
		'match',
		['get', 'signal_type'],

		// signal_type === 'adsb'
		'adsb',
		[
			'match',
			['get', 'adsb_emitter_type'],
			'single_engine',
			'single_engine_airplane_icon',
			'jet',
			'jet_airplane_icon',
			'helicopter',
			'helicopter_icon',
			'large',
			'large_airplane_icon',
			// default airplane icon
			'airplane_icon'
		],

		// default signal_type → object_type
		[
			'match',
			['get', 'object_type'],
			'uav',
			'drone_icon',
			'asterix',
			'chevron_icon',
			'sensor',
			'radar_icon',
			// default airplane icon
			'airplane_icon'
		]
	]
];

export const aircraftOutlineIconExpression = [
	'case',
	// is_sim === true → simulator
	['==', ['get', 'is_sim'], true],
	'simulator_outline_icon',

	// else:
	[
		'match',
		['get', 'signal_type'],

		// signal_type === 'adsb'
		'adsb',
		[
			'match',
			['get', 'adsb_emitter_type'],
			'single_engine',
			'single_engine_airplane_outline_icon',
			'jet',
			'jet_airplane_outline_icon',
			'helicopter',
			'helicopter_outline_icon',
			'large',
			'large_airplane_outline_icon',
			// default airplane icon
			'airplane_outline_icon'
		],

		// default signal_type → object_type
		[
			'match',
			['get', 'object_type'],
			'uav',
			'drone_outline_icon',
			'asterix',
			'chevron_outline_icon',
			'sensor',
			'radar_outline_icon',
			// default airplane icon
			'airplane_outline_icon'
		]
	]
];

export const aircraftDoubleOutlineIconExpression = [
	'case',
	// is_sim === true → simulator
	['==', ['get', 'is_sim'], true],
	'simulator_double_outline_icon',

	// else:
	[
		'match',
		['get', 'signal_type'],

		// signal_type === 'adsb'
		'adsb',
		[
			'match',
			['get', 'adsb_emitter_type'],
			'single_engine',
			'single_engine_airplane_double_outline_icon',
			'jet',
			'jet_airplane_double_outline_icon',
			'helicopter',
			'helicopter_double_outline_icon',
			'large',
			'large_airplane_double_outline_icon',
			// default airplane icon
			'airplane_double_outline_icon'
		],

		// default signal_type → object_type
		[
			'match',
			['get', 'object_type'],
			'uav',
			'drone_double_outline_icon',
			'asterix',
			'chevron_double_outline_icon',
			'sensor',
			'radar_double_outline_icon',
			// default airplane icon
			'airplane_double_outline_icon'
		]
	]
];

export const opsViewUsersCluserCircleLayerId = 'ops_view_users_cluster_circle_layer';
export const opsViewUsersClusterCountLayerId = 'ops_view_users_cluster_count_layer';
export const opsViewClusterLayers = [
	opsViewUsersCluserCircleLayerId,
	opsViewUsersClusterCountLayerId
];
